/**
 * Compress an image File using canvas before uploading to Firebase Storage.
 * Reduces storage cost and download bandwidth.
 *
 * @param {File} file - Original image file
 * @param {object} opts
 * @param {number} opts.maxWidth  - Max width in px (default 800)
 * @param {number} opts.maxHeight - Max height in px (default 800)
 * @param {number} opts.quality   - JPEG quality 0–1 (default 0.78)
 * @returns {Promise<Blob>} Compressed image blob (image/jpeg)
 */
export function compressImage(file, { maxWidth = 800, maxHeight = 800, quality = 0.78 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width  = Math.round(width  * ratio);
        height = Math.round(height * ratio);
      }
      const canvas = document.createElement("canvas");
      canvas.width  = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(img, 0, 0, width, height);
      canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error("Compression failed")), "image/jpeg", quality);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Failed to load image")); };
    img.src = url;
  });
}
